import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'


// region SETUP / Redux store -------------------------------------------------------------------------------
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import {store, history, persistor} from 'redux/store.js'
import { PersistGate } from 'redux-persist/integration/react'
// endregion SETUP / Redux store -------------------------------------------------------------------------------


//#region AppRoot
const Loading = (props) => null // <div>LOADING</div>
const onBeforeLift = (store) => {
    if(process.env.NODE_ENV === 'development'){
        console.log('About to lift PersistGate.', store)
    }
}

const AppRoot = (props) => {
  return(
          <Provider store = {store}>
              <PersistGate loading={<Loading />} persistor={persistor} onBeforeLift={()=>onBeforeLift(store)}>
                  <ConnectedRouter history={history}>
                      <App />
                  </ConnectedRouter>
              </PersistGate>
          </Provider>
  )
}
//#endregion


ReactDOM.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


